import { useSelector } from 'react-redux';
import { selectCurrentUser, selectIsAuthenticated, selectCurrentUserRole } from '../store/slices/authSlice';
import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';
import { useLoading } from '../components/LoadingProvider';

export default function useAuth({ redirectPath = '/login', allowedRoles = ['patient'] }) {
    const { setIsLoading } = useLoading();
    const user = useSelector(selectCurrentUser);
    const isAuthenticated = useSelector(selectIsAuthenticated);
    const userRole = useSelector(selectCurrentUserRole);
    const navigate = useNavigate();
    
    useEffect(() => {
        setIsLoading(false);
        // Check authentication status
        if (!isAuthenticated || !user) {
            setIsLoading(true);
            navigate(redirectPath);
            return;
        }
        // Check user role
        if (!allowedRoles.includes(userRole)) {
            navigate(redirectPath);
            return;
        }
    }, []);

    return {
        user,
        isAuthenticated,
        userRole
    };
}